import React from 'react'
import styled from 'styled-components'
const InfoPanel = ({ text, iconFont, background, link }) => {
  return (
    <InfoWrapper background={background}>
      <i className={`fas ${iconFont}`} />
      <span>{text}</span>
      {link && (
        <a href={link.url} target="_blank" rel="noreferrer">
          {link.text}
        </a>
      )}
    </InfoWrapper>
  )
}
export default InfoPanel

const InfoWrapper = styled.div`
  margin-bottom: 20px;
  font-size: 13px;
  padding: 10px;
  color: #555555;
  font-weight: bold;
  i {
    font-size: 15px;
    padding-right: 7px;
  }
  a {
    display: block;
    margin-left: 24px;
  }
  background: ${({ background }) => {
    if (background === 'yellow') return '#ffde9d'
    if (background === 'grey') return '#EDEDED'
  }};
`
